package com.fireavert.react.pages.reports

import com.fireavert.cache.client.Preferences
import com.fireavert.properties.shared.data_models.FireClaimData
import com.fireavert.react.pages.reports.dialogs.ReportsExportDataDialog
import com.fireavert.react.pages.reports.styles.ReportPageStyles
import com.fireavert.react.shared.LoggedIn
import com.fireavert.react.shared.components.cards.AdminUserBoxes
import com.fireavert.react.shared.styles.DialogStyles.largeHeading
import com.fireavert.react.shared.styles.MobileStyles.MOBILE_VIEW_WIDTH
import com.fireavert.reports_page.reports_page.client.presentation.ReportsPageSectionController
import com.fireavert.reports_page.reports_page.client.presentation.ReportsPageViewModel
import com.fireavert.reports_page.reports_page.data_models.HighRiskTenantModel
import com.fireavert.reports_page.shared.data_models.EventTypes
import com.fireavert.utilities.getKoinInstance
import com.fireavert.utilities.saveAs
import emotion.react.css
import kotlinx.browser.window
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.launchIn
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.launch
import kotlinx.datetime.Clock
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import mui.material.*
import mui.system.sx
import mui.system.useMediaQuery
import org.w3c.files.Blob
import org.w3c.files.BlobPropertyBag
import react.FC
import react.ReactNode
import react.dom.html.ReactHTML.div
import react.router.useNavigate
import react.useEffectOnceWithCleanup
import react.useState
import web.cssom.*
import kotlin.math.absoluteValue
import kotlin.math.roundToInt
import web.dom.ElementId
import kotlin.math.abs


data class SimpleMenuItem(
    override val value: String,
    override val label: String
) : SelectMenuItem

val ReportSection = FC {

    val controller = getKoinInstance<ReportsPageSectionController>()
    val viewModel = getKoinInstance<ReportsPageViewModel>()
    val preferences = getKoinInstance<Preferences>()
    val navigate = useNavigate()
    //global variables for the report section
    val isMobile = useMediaQuery(MOBILE_VIEW_WIDTH)
    var windowWidth by useState(0)

    var selectedAllProperties: Boolean by useState(false)
    var highRiskTenantsRecord: List<HighRiskTenantModel> by useState(emptyList())
    var averageEventsPerMonth: Double by useState(0.0)
    var propertyAverage: Pair<Double, Boolean> by useState(Pair(0.0, false))
    var allTimeAverageEventValue: Double by useState(0.0)

    var propertyId: Int? by useState(preferences.globalProperty)
    var propertyMap: Map<String, Int?> by useState(mapOf("None" to -1, "All" to null))
    var loading: Boolean by useState(false)
    var loadingHighRiskTenants: Boolean by useState(false)
    var loadingYearlyEvents: Boolean by useState(false)
    var loadingAllTimeEvents: Boolean by useState(false)
    var loadingDeviceToEventRatio: Boolean by useState(false)

    var firesAverted: Int by useState(0)

    var thisYearSmokeEvents: Array<Int> by useState(emptyArray())
    var thisYearTamperEvents: Array<Int> by useState(emptyArray())
    var thisYearLeakEvents: Array<Int> by useState(emptyArray())
    var thisYearStoveShutoffEvents: Array<Int> by useState(emptyArray())
    var thisYearOfflineEvents: Array<Int> by useState(emptyArray())
    var allTimeData: Map<String, Int> by useState(emptyMap())
    var allTimeDeviceCount: Array<Int> by useState(emptyArray())
    var yearDeviceCount: Array<Int> by useState(emptyArray())
    var eventCount: Int by useState(0)
    val months = arrayOf(
        "JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
    )
    var chartName: String by useState("Smoke Events")
    val currentYear = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).year
    val yearSelector = (2020..currentYear).toList().reversed().toTypedArray()
    var eventTypeSelector: String by useState("Smoke Events")
    var eventTypeSelectorRatio: String by useState("Smoke Events")
    var availableDeviceTypes: List<EventTypes> by useState(emptyList())
    var deviceToEventRatio: Array<Double> by useState(emptyArray())
    var deviceToOfflineEventRatio: Array<Double> by useState(emptyArray())

    //Get the last 5 years in reversed order as a string for the graph
    val lastFiveYears = (currentYear - 4..currentYear).map { it.toString() }.toTypedArray()
    var lastFiveYearClaims: List<FireClaimData> by useState(emptyList())
    var yearStartedUsingFireAvert: Int by useState(0)
    var selectedYear: Int by useState(currentYear)

    var reloadJob: Job? = null
    val (openDialog, setOpenDialog) = useState(false)
    var exportError: String? by useState(null)

    val chartWidth = if (isMobile) windowWidth else (windowWidth * 0.8).toInt()
    useEffectOnceWithCleanup {
        val viewStateJob = viewModel.viewState.onEach { viewState ->
            loading = viewState.loading
            loadingHighRiskTenants = viewState.loadingHighRiskTenants
            loadingYearlyEvents = viewState.loadingYearlyEvents
            loadingAllTimeEvents = viewState.loadingAllTimeEvents
            loadingDeviceToEventRatio = viewState.loadingDeviceToEventRatio
            propertyId = viewState.propertyId
            propertyMap = viewState.propertyMap
            thisYearTamperEvents = viewState.thisYearTamperEvents
            thisYearLeakEvents = viewState.thisYearLeakEvents
            thisYearStoveShutoffEvents = viewState.thisYearStoveShutoffEvents
            thisYearSmokeEvents = viewState.thisYearSmokeEvents
            thisYearOfflineEvents = viewState.thisYearOfflineEvents
            allTimeData = viewState.allTimeData
            eventCount = viewState.eventCount
            highRiskTenantsRecord = viewState.highRiskTenants
            averageEventsPerMonth = viewState.averageEventsPerMonth
            propertyAverage = viewState.propertyAverageComparison
            allTimeAverageEventValue = viewState.allTimeAverageEventValue
            lastFiveYearClaims = viewState.lastFiveYearClaims
            yearStartedUsingFireAvert = viewState.yearStartedUsingFireAvert
            windowWidth = window.innerWidth
            allTimeDeviceCount = viewState.allTimeDeviceCount
            yearDeviceCount = viewState.yearlyDeviceCount
            deviceToEventRatio = viewState.deviceToEventRatio
            exportError = viewState.exportError
            deviceToOfflineEventRatio = viewState.deviceToOfflineEventRatio
            firesAverted = viewState.firesAvertedCount
            availableDeviceTypes = viewState.availableDeviceTypes


        }.launchIn(viewModel.scope)

        val onLoadJob = viewModel.scope.launch {
            controller.onLoad(propertyId, eventTypeSelector, currentYear)
        }

        onCleanup {
            onLoadJob.cancel()
            viewStateJob.cancel()
        }
    }

    fun updateYearChart(newPropertyId: Int?, yearToGet: Int) {
        reloadJob?.cancel()
        reloadJob = viewModel.scope.launch {
            controller.loadYearlyEventTrends(newPropertyId, yearToGet)
        }
    }

    fun updateHighRiskTenants(propertyId: Int?, eventTypeArray: List<String>) {
        reloadJob?.cancel()
        reloadJob = viewModel.scope.launch {
            controller.loadHighRiskTenantData(propertyId, eventTypeArray)
        }
    }

    fun updateActionsAndEvents(propertyId: Int?, eventTypeValue: String) {
        reloadJob?.cancel()
        reloadJob = viewModel.scope.launch {
            controller.loadEventsAndActions(propertyId, eventTypeValue)
        }
    }

    fun updateDeviceToEventRatio(propertyId: Int?, deviceCount: Array<Int>, eventTypeValue: String) {
        reloadJob?.cancel()
        reloadJob = viewModel.scope.launch {
            controller.loadDeviceToEventRatio(propertyId, deviceCount, eventTypeValue)
        }
    }

    //ALL THE DEVICE COUNT COMES BACK BUT ONLY IN THE MONTH THEY WERE ADDED, WE NEED TO HAVE THE NUMBER GROW AND BE SORTED EVERY MONTH

    val averageComparedToAllTime = if (allTimeAverageEventValue != 0.0) {
        ((averageEventsPerMonth - allTimeAverageEventValue) / allTimeAverageEventValue) * 100
    } else 0.0

    LoggedIn {}
    div {
        div {
            className = ReportPageStyles.buttonAndTitle
            div {
                div {
                    className = largeHeading
                    +"Reports"
                }
            }

            div {
                css {
                    alignContent = AlignContent.center
                }
                if (!isMobile) {
                    Button {
                        variant = ButtonVariant.contained
                        disabled = propertyId == -1
                        onClick = {
                            setOpenDialog(true)
                        }
                        +"Export Historical Data"
                    }
                    Button {
                        sx {
                            marginLeft = 10.px
                        }
                        variant = ButtonVariant.contained
                        disabled = propertyId == -1
                        onClick = {
                            viewModel.scope.launch {
                                val exportedData = controller.exportEventsHappeningNow(propertyId)

                                // Generate the CSV content as a string using the exported data
                                // Create a Blob from the CSV content
                                if (exportedData != null) {
                                    val blob =
                                        Blob(arrayOf(exportedData), BlobPropertyBag(type = "text/csv;charset=utf-8;"))

                                    // Use the saveAs function to prompt the user to download the file
                                    saveAs(blob, "events_happening_now.csv")
                                }
                            }
                        }
                        +"Export Events Happening Now"
                        Snackbar {
                            open = exportError != null
                            onClose = { _, _ ->
                                exportError = null
                            }
                            message = ReactNode(exportError ?: "An error occurred while exporting data")
                            autoHideDuration = 5000
                            anchorOrigin = object : SnackbarOrigin {
                                override var vertical = SnackbarOriginVertical.bottom
                                override var horizontal = SnackbarOriginHorizontal.right
                            }
                        }
                    }
                }
            }
            if (openDialog) {
                ReportsExportDataDialog {
                    propsPropertyId = propertyId
                    propsIsAdmin = preferences.isAdmin
                    propsPropertyName = propertyMap.entries.find { it.value == propertyId }?.key ?: ""
                    onClose = { setOpenDialog(false) }
                }
            }
        }
        div {
            className = ReportPageStyles.reportPageStyle
            div {
                className = ReportPageStyles.headingAndDropDownContainer
                div {
                    className = ReportPageStyles.titleHeading
                    +"Monthly Property Stats"
                }
            }
            div {
                className = ReportPageStyles.propertyStats

                AdminUserBoxes {
                    this.boxTitle = "Event Average"
                    this.boxValue = "${averageEventsPerMonth.toInt()}"
                    this.loading = loadingHighRiskTenants
                    this.clickable = false
                }
                AdminUserBoxes {
                    this.boxTitle = "Average For All FireAvert Properties"
                    this.boxValue = "${allTimeAverageEventValue.toInt()}"
                    this.loading = loadingHighRiskTenants
                    this.clickable = false
                }
                if (averageComparedToAllTime < 0) {
                    AdminUserBoxes {
                        this.boxTitle = "Percentage Less Than Average"
                        this.boxValue = "${averageComparedToAllTime.roundToInt().absoluteValue}%"
                        this.loading = loadingHighRiskTenants
                        this.clickable = false
                        this.color = NamedColor.green
                    }
                }
                if (averageComparedToAllTime > 0) {
                    AdminUserBoxes {
                        this.boxTitle = "Percentage Greater Than Average"
                        this.boxValue = "${averageComparedToAllTime.roundToInt()}%"
                        this.loading = loadingHighRiskTenants
                        this.clickable = false
                        this.color = NamedColor.red
                    }
                }
            }

        }

        div {
            className = ReportPageStyles.titleHeading
            +"Potential Fires Averted"
        }
        if (!loadingYearlyEvents) {
            div {
                className = ReportPageStyles.costSavingsContainer
                div {
                    className = ReportPageStyles.firesAvertedValue
                    +"$firesAverted"
                }
                div {
                    className = ReportPageStyles.costsSavingsText
                    +"Estimated Savings: "
                    if (lastFiveYearClaims.isEmpty() || lastFiveYearClaims.all { it.claimCount == 0 }) {
                        Button {
                            onClick = {
                                window.open("https://forms.gle/dWdcJbVS9sVatK8v7", "_blank")
                            }
                            sx {
                                borderRadius = 10.px
                                backgroundColor = Color("#CF3338")
                            }
                            variant = ButtonVariant.contained
                            +"Fill Out Loss Report"
                        }
                    } else {
                        +"$${(lastFiveYearClaims.sumOf { it.cost })}"
                    }
                }
            }
        } else {
            Skeleton {
                sx {
                    borderRadius = 10.px
                }
                variant = SkeletonVariant.rectangular
                width = 110.pct
                height = 300.px
            }
        }
        EventsOverTimeChart {
            loadingProp = loading
            lastFiveYearsProp = lastFiveYears
            lastFiveYearClaimsProp = lastFiveYearClaims.toTypedArray()
            yearStartedUsingFireAvertProp = yearStartedUsingFireAvert
            chartWidthProp = chartWidth
            propertyIdProps = propertyId
        }

        // Yearly Event Trend Chart
        ReportsGraphComponentInt {
            loadingProp = loadingYearlyEvents
            xAxisData = arrayOf(jsObject {
                id = "months"
                this.data = months
                scaleType = "band"
            })
            seriesData = if (preferences.isAdmin) {
                arrayOf(jsObject {
                    this.data = thisYearSmokeEvents
                    stack = "A"
                    label = "Smoke Events"
                    color = "#FF5E5B"
                }, jsObject {
                    this.data = thisYearLeakEvents
                    stack = "B"
                    label = "Water Leak Events"
                    color = "#58B9FF"
                }, jsObject {
                    this.data = thisYearTamperEvents
                    stack = "C"
                    label = "Tamper Events"
                    color = "#FECA57"
                }, jsObject {
                    this.data = thisYearStoveShutoffEvents
                    stack = "D"
                    label = "Stove ShutOff Events"
                    color = "#262626"
                }, jsObject {
                    this.data = thisYearOfflineEvents
                    stack = "E"
                    label = "Offline Events"
                    color = "#D3D3D3"
                }, jsObject {
                    this.data = yearDeviceCount
                    stack = "F"
                    label = "Sensor Count"
                    color = "#5E5D5C"
                })
            } else {
                arrayOf(jsObject {
                    this.data = thisYearSmokeEvents
                    stack = "A"
                    label = "Smoke Events"
                    color = "#FF5E5B"
                }, jsObject {
                    this.data = thisYearLeakEvents
                    stack = "B"
                    label = "Water Leak Events"
                    color = "#58B9FF"
                }, jsObject {
                    this.data = thisYearTamperEvents
                    stack = "C"
                    label = "Tamper Events"
                    color = "#FECA57"
                }, jsObject {
                    this.data = thisYearStoveShutoffEvents
                    stack = "D"
                    label = "Stove ShutOff Events"
                    color = "#262626"
                }, jsObject {
                    this.data = yearDeviceCount
                    stack = "E"
                    label = "Sensor Count"
                    color = "#5E5D5C"
                })
            }
            chartHeight = 500
            this.chartWidth = chartWidth
            this.isMobile = isMobile
            menuItemList = yearSelector.map { year ->
                SimpleMenuItem(
                    value = year.toString(),
                    label = year.toString()
                )
            }.toTypedArray()
            onChangeProp = { event ->
                val year = event.target.value as String
                selectedYear = year.toInt()
                updateYearChart(propertyId, year.toInt())
            }
            this.chartName = "Yearly Event Trends"
            inputLabel = "Year"
            initialSelectValue = selectedYear.toString()
        }

        // All Time Event Trend Chart
        if (selectedAllProperties) {
            ReportsGraphComponentInt {
                loadingProp = loadingAllTimeEvents
                xAxisData = arrayOf(jsObject {
                    id = "months"
                    this.data = allTimeData.keys.toTypedArray()
                    scaleType = "band"
                })
                seriesData = arrayOf(
                    jsObject {
                        this.data = allTimeData.values.toTypedArray()
                        stack = "A"
                        label = "$chartName All Time"
                    },
                    jsObject {
                        this.data = allTimeDeviceCount
                        stack = "B"
                        label = "Sensor Count"
                        color = "#5E5D5C"
                    })
                chartHeight = 500
                this.chartWidth = chartWidth
                this.isMobile = isMobile
                menuItemList = arrayOf(
                    SimpleMenuItem("Smoke Events", "Smoke Events"),
                    SimpleMenuItem("Leak Events", "Leak Events"),
                    SimpleMenuItem("Tamper Events", "Tamper Events"),
                    SimpleMenuItem("Stove Shutoff Events", "Stove Shutoff Events")
                )
                onChangeProp = { event ->
                    val eventType = event.target.value as String
                    eventTypeSelector = eventType
                    chartName = eventType
                    updateActionsAndEvents(propertyId, eventType)
                }
                this.chartName = "All Time Events"
                inputLabel = "Event Type"
                initialSelectValue = eventTypeSelector
            }
        } else {
            ReportsGraphComponentInt {
                loadingProp = loadingAllTimeEvents
                xAxisData = arrayOf(jsObject {
                    id = "months"
                    this.data = allTimeData.keys.toTypedArray()
                    scaleType = "band"
                })
                seriesData = arrayOf(
                    jsObject {
                        this.data = allTimeData.values.toTypedArray()
                        stack = "A"
                        label = "$chartName All Time"
                    })
                chartHeight = 500
                this.chartWidth = chartWidth
                this.isMobile = isMobile
                menuItemList = arrayOf(
                    SimpleMenuItem("Smoke Events", "Smoke Events"),
                    SimpleMenuItem("Leak Events", "Leak Events"),
                    SimpleMenuItem("Tamper Events", "Tamper Events"),
                    SimpleMenuItem("Stove Shutoff Events", "Stove Shutoff Events")
                )
                onChangeProp = { event ->
                    val eventType = event.target.value as String
                    eventTypeSelector = eventType
                    chartName = eventType
                    updateActionsAndEvents(propertyId, eventType)
                }
                this.chartName = "All Time Events"
                inputLabel = "Event Type"
                initialSelectValue = eventTypeSelector
            }
        }

        //Device to event ratio
        ReportsGraphComponentDouble {
            loadingProp = loadingDeviceToEventRatio
            xAxisData = arrayOf(jsObject {
                id = "months"
                this.data = allTimeData.keys.toTypedArray()
                scaleType = "band"
            })
            seriesData = if (preferences.isAdmin) {
                arrayOf(jsObject {
                    this.data = deviceToEventRatio
                    stack = "A"
                    label = "Sensor to Event Ratio"
                }, jsObject {
                    this.data = deviceToOfflineEventRatio
                    stack = "B"
                    label = "Sensor to Offline Event Ratio"
                    color = "#5E5D5C"
                })
            } else {
                arrayOf(jsObject {
                    this.data = deviceToEventRatio
                    stack = "A"
                    label = "Sensor to Event Ratio"
                })
            }
            chartHeight = 500
            this.chartWidth = chartWidth
            this.isMobile = isMobile
            menuItemList = arrayOf(
                SimpleMenuItem("Smoke Events", "Smoke Events"),
                SimpleMenuItem("Leak Events", "Leak Events"),
                SimpleMenuItem("Tamper Events", "Tamper Events"),
            )
            onChangeProp = { event ->
                val eventType = event.target.value as String
                eventTypeSelectorRatio = eventType
                chartName = eventType
                updateDeviceToEventRatio(propertyId, allTimeDeviceCount, eventType)
            }
            this.chartName = "Events per Active Sensor"
            inputLabel = "Event Type"
            initialSelectValue = eventTypeSelectorRatio
            chartDescription =
                "Average number of events triggered per installed sensor each month, categorized by event type."
        }
    }
}



// Helper function to create JavaScript objects
inline fun <T> jsObject(builder: T.() -> Unit): T {
    return (js("{}") as T).apply(builder)
}